import { COUNTRY_LIST_DROPDOWN_OPTIONS } from '../helper/Country';
import { TYPOGRAPHY } from './Typographys';

export const INDIVIDUAL_PROFILE_FORM_FIELDS = {
  PROFILE_PAGE_CONFIG: {
    HEADER: {
      text: 'Profile',
      type: TYPOGRAPHY.TITLE,
    },
  },
  FIRST_NAME_FIELD: {
    formItemProps: {
      name: 'firstName',
      colon: false,
      required: true,
    },
    inputProps: {
      label: 'Enter first name',
      type: 'text',
      placeholder: 'Enter Full Name',
    },
  },
  LAST_NAME_FIELD: {
    formItemProps: {
      name: 'lastName',
      colon: false,
      required: true,
    },
    inputProps: {
      label: 'Enter last name',
      type: 'text',
      placeholder: 'Enter Full Name',
    },
  },
  DATE_OF_BIRTH_FIELD: {
    formItemProps: {
      name: 'dob',
      colon: false,
      required: true,
    },
    dateProps: {
      placeholder: 'DD-MM-YYYY',
      label: 'Date Of Birth',
      format: 'DD-MM-YYYY',
    },
  },
  COUNTRY_DROPDOWN_FIELD: {
    formItemProps: {
      name: 'country',
      colon: false,
      required: true,
    },
    selectProps: {
      label: 'Country',
      require: true,
      placeholder: 'Select Country',
      options: COUNTRY_LIST_DROPDOWN_OPTIONS.map((countyOption) => {
        return {
          label: countyOption.label,
          searchText: countyOption.label,
          value: countyOption.value,
          formValue: countyOption.value,
        };
      }),

      showSearch: true,
    },
  },
  STATE_FIELD: {
    formItemProps: {
      name: 'state',
      colon: false,
      required: true,
    },
    inputProps: {
      label: 'State',
      type: 'text',
      placeholder: 'Enter State',
    },
  },
  ADDRESS_FIELD: {
    formItemProps: {
      name: 'address',
      colon: false,
      required: true,
    },
    inputProps: {
      label: 'Address',
      type: 'text',
      placeholder: 'Enter Address',
    },
  },
  PHONE_NUMBER_FIELD: {
    formItemProps: {
      // name: "mobileNo",
      colon: false,
      required: true,
    },
    inputProps: {
      controls: false,
      label: 'Phone Number',
      type: 'number',
      placeholder: 'Enter Phone Number',
    },
  },
  PROFILE_IMAGE_PROPS: {
    props: {
      // src: smallLogo,
      hasBorder: false,
      size: 132,
    },
  },

  EMAIL_ADDRESS_FIELD: {
    formItemProps: {
      name: 'emailId',
      colon: false,
      required: true,
    },
    inputProps: {
      label: 'Email',
      type: 'email',
      placeholder: 'Email Address',
    },
  },
  COMPANY_NAME_FIELD: {
    formItemProps: {
      name: 'companyName',
      colon: false,
      required: false,
    },
    inputProps: {
      label: 'Organisation Name (Optional)',
      type: 'text',
      placeholder: 'Organisation Name',
    },
  },
  JOB_ROLE_FIELD: {
    formItemProps: {
      name: 'jobRole',
      colon: false,
      required: false,
    },
    inputProps: {
      label: 'Job Role (Optional)',
      type: 'text',
      placeholder: 'Job Role',
    },
  },
  GENDER_DROPDOWN_FIELD: {
    formItemProps: {
      name: 'gender',
      colon: false,
      required: true,
    },
    selectProps: {
      label: 'Gender',
      placeholder: 'Select Gender',
      options: [
        { label: 'Male', value: 'male' },
        { label: 'Female', value: 'female' },
        { label: 'Other', value: 'other' },
      ],
    },
  },
};

export const PROFILE_FORM_CTA = {
  SAVE_BUTTON: {
    buttonProps: {
      type: 'primary',
      text: 'Save',
    },
  },
};

export const COMPLETION_TEXT = {
  text: '10% Complete',
  type: TYPOGRAPHY.SUBTITLE_BIG_BLACK,
};

export const MANAGER_PROFILE_FORM_FIELDS = {
  PROFILE_PAGE_CONFIG: {
    HEADER: {
      text: 'Manager Profile',
      type: TYPOGRAPHY.TITLE,
    },
  },
  FULL_NAME_FIELD: {
    formItemProps: {
      name: 'fullName',
      colon: false,
      required: true,
    },
    inputProps: {
      label: 'Enter your full name',
      type: 'text',
      placeholder: 'Enter Full Name',
    },
  },
  DATE_OF_BIRTH_FIELD: {
    formItemProps: {
      name: 'dateOfBirth',
      colon: false,
      required: true,
    },
    datePickerProps: {
      label: 'Date of Birth',
      placeholder: 'Select Date',
      format: 'DD-MM-YYYY',
    },
  },
  COUNTRY_DROPDOWN_FIELD: {
    formItemProps: {
      name: 'country',
      colon: false,
      required: true,
    },
    selectProps: {
      label: 'Country',
      placeholder: 'Select Country',
      options: COUNTRY_LIST_DROPDOWN_OPTIONS,
      showSearch: true,
      filterOption: (inputValue, option) => {
        return option.label.toLowerCase().includes(inputValue.toLowerCase());
      },
    },
  },
  STATE_FIELD: {
    formItemProps: {
      name: 'state',
      colon: false,
      required: true,
    },
    inputProps: {
      label: 'State',
      type: 'text',
      placeholder: 'Enter State',
    },
  },
  ADDRESS_FIELD: {
    formItemProps: {
      name: 'address',
      colon: false,
      required: true,
    },
    inputProps: {
      label: 'Address',
      type: 'text',
      placeholder: 'Enter Address',
    },
  },
  PHONE_NUMBER_FIELD: {
    formItemProps: {
      name: 'mobileNo',
      colon: false,
      required: true,
    },
    inputProps: {
      controls: false,
      label: 'Phone Number',
      type: 'number',
      placeholder: 'Enter Phone Number',
    },
  },
  PROFILE_IMAGE_PROPS: {
    props: {
      //   src: smallLogo,
      size: 106,
      hasBorder: false,
    },
  },

  WORK_EMAIL_ADDRESS_FIELD: {
    formItemProps: {
      name: 'emailAddress',
      colon: false,
      required: true,
    },
    inputProps: {
      label: 'Email Address (Work)',
      type: 'email',
      placeholder: 'Email Address',
    },
  },
  PERSONAL_EMAIL_ADDRESS_FIELD: {
    formItemProps: {
      name: 'emailAddress',
      colon: false,
      required: true,
    },
    inputProps: {
      label: 'Secondery Email Address (Personal)',
      type: 'email',
      placeholder: 'Email Address',
    },
  },
  COMPANY_NAME_FIELD: {
    formItemProps: {
      name: 'companyName',
      colon: false,
      required: false,
    },
    inputProps: {
      label: 'Organisation Name (Optional)',
      type: 'text',
      placeholder: 'Organisation Name',
    },
  },
  JOB_ROLE_FIELD: {
    formItemProps: {
      name: 'jobRole',
      colon: false,
      required: false,
    },
    inputProps: {
      label: 'Job Role (Optional)',
      type: 'text',
      placeholder: 'Job Role',
    },
  },
  GENDER_DROPDOWN_FIELD: {
    formItemProps: {
      name: 'gender',
      colon: false,
      required: true,
    },
    selectProps: {
      label: 'Gender',
      placeholder: 'Select Gender',
      options: [
        { label: 'Male', value: 'male' },
        { label: 'Female', value: 'female' },
        { label: 'Other', value: 'other' },
      ],
    },
  },
};
